import glideImage from "@/utils/glideImage";
import { videoSrc } from "@/utils/media.js";
import s from "@/components/Misc/VideoImageContainer.module.scss";

const VideoImageContainer = ({ mediaType, videoUrl, image }) => {
  const isVideo = mediaType === "r2_video";
  const isImage = mediaType === "image";

  return (
    <div className={s.videoImageWrapper}>
      {isImage && (
        <img
          src={glideImage(image, { w: 767 })}
          alt={`${window.general_settings?.brand_name ?? ""} Overview`}
          className={s.videoImageWrapper__image}
        />
      )}
      {isVideo && (
        <video
          style={{ width: "100%", height: "100%" }}
          className={s.videoImageWrapper__video}
          muted
          loop
          autoPlay
          playsInline
        >
          <source src={videoSrc(videoUrl)} type="video/mp4" />
        </video>
      )}
    </div>
  );
};

export default VideoImageContainer;
